document.addEventListener('DOMContentLoaded', function () {
  var headerWrapper = document.querySelector('.header-wrapper');
  if (!headerWrapper) return;

  function setHeaderHeightVar() {
    var height = headerWrapper.getBoundingClientRect().height;
    document.documentElement.style.setProperty(
      '--transparent-header-height',
      height + 'px'
    );
  }

  function toggleHeader() {
    if (window.scrollY > 80) {
      headerWrapper.classList.add('scrolled');
    } else {
      headerWrapper.classList.remove('scrolled');
    }
  }

  setHeaderHeightVar();
  toggleHeader();

  window.addEventListener('scroll', toggleHeader, { passive: true });
  window.addEventListener('resize', setHeaderHeightVar);
});
